import { formatNumber } from 'helpers/utils';
import React from 'react';
import { Card } from 'components/common';
import { FaAddressCard, FaChessQueen } from 'react-icons/fa';
import { MdAccountBalance } from 'react-icons/md';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

const infoRow = (label, value) => (
  <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
    <div className="tw-col-span-12 sm:tw-col-span-3 tw-text-left">{label}</div>
    <div className="tw-col-span-12 sm:tw-col-span-9">
      <span className="tw-text-blue-600">{value}</span>
    </div>
  </div>
);

const ConvertPCVComponent = ({lead}) => {
  const contact = lead?.contacts[0] || [];
  const opportunity = lead?.opportunity || {};
  const customer = lead?.customer || {};

  return (
    <div className="tw-grid tw-grid-cols-12 tw-gap-3 tw-text-sm tw-mt-3">
      <div className="tw-col-span-12 md:tw-col-span-4">
        <Card
          className="tw-h-full"
          header={<h3 className="tw-font-semibold tw-text-sm tw-text-blue-600"><MdAccountBalance /> Customer</h3>}
        >
          {infoRow('Name:', lead?.account_name)}
          {infoRow('Work phone:', lead?.work_phone)}
          {infoRow('Address:', '60A Truong Son, Phuong 2, Quan Tan Binh.')}
          {infoRow('Website:', lead?.website)}
        </Card>
      </div>
      <div className="tw-col-span-12 md:tw-col-span-4">
        <Card
          className="tw-h-full"
          header={<h3 className="tw-font-semibold tw-text-sm tw-text-blue-600"><FaAddressCard /> Contact</h3>}
        >
          {infoRow('Name:', contact?.name)}
          {infoRow('Title:', contact?.position)}
          {infoRow('Mobile:', contact?.mobile)}
          {infoRow('Email:', contact?.email)}
        </Card>
      </div>
      <div className="tw-col-span-12 md:tw-col-span-4">
        <Card
          className="tw-h-full"
          header={<h3 className="tw-font-bold tw-text-sm tw-text-green-600"><FaChessQueen /> Opportunity</h3>}
        >
          {infoRow('Name:', (
            <Link to={`/crm/projects/${opportunity?.id}`} target="_blank">{lead?.project_name}</Link>
          ))}
          {infoRow('Account name:', (
            <Link to={`/crm/customers/${customer?.id}`} target="_blank">{customer?.name}</Link>
          ))}
          {infoRow('Amount:', `$${formatNumber(lead?.amount)}`)}
          {infoRow('Sales incharge:', lead?.salesperson)}
        </Card>
      </div>
    </div>
  )
};

ConvertPCVComponent.propTypes = {
  lead: PropTypes.object.isRequired
}

export default ConvertPCVComponent;
